import { styled } from "@mui/material"

export const LayoutContainer = styled("div")({
  margin: "0 auto",
})